import { QuestionBase } from './question-base';
import { OptionQuestion } from './question-option';

export class DropdownQuestion extends QuestionBase<string> {
    controlType = 'dropdown';
    options: OptionQuestion[] = [];

    constructor(options: {} = {}) {
        super(options);
        this.options = options['options'] || [];
    }
}
